<style>
  .stepContainer {
    background-color: #F2F2F2;
    padding: 10px;
    border-radius: 5px;
  }
</style>
<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>设备调试</span>
        </div>
      </div>
      <div class="coreMain" style="padding-top: 10px">
        <el-card class="box-card">
          <el-steps :active="step" space="26%" finish-status="success">
            <el-step title="调试配置" icon="el-icon-finished"></el-step>
            <el-step title="填写上报数据" icon="el-icon-edit"></el-step>
            <el-step title="查看平台日志" icon="el-icon-view"></el-step>
          </el-steps>
          <el-row :gutter="15" style="margin-top: 20px">
            <el-col :span="6">
              <div class="grid-content stepContainer">
                <div>
                  选择需要调试的设备：
                </div>
                <el-select style="width:100%" v-model="deviceId" :disabled="step!=0" placeholder="请选择需要调试的设备">
                  <el-option v-for="item in deviceList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <div style="text-align: center;margin-top: 10px">
                  <el-button type="primary" round v-if="step==0" @click="connect" :disabled="deviceId==''">连接后台
                  </el-button>
                  <el-button type="primary" round v-if="step!=0" @click="breakOff">关闭连接</el-button>
                </div>
              </div>

              <div class="grid-content stepContainer" style="margin-top: 10px">
                <div>
                  可选配置(连接后配置)：
                </div>
                <div style="margin-top: 15px;">
                  <p style="color:#FF2525;font-size:10px;margin-bottom: 5px">需要登录的网关需先登录后再调试，否则会导致连接断开。</p>
                  登录包/注册包格式：&nbsp;
                  <el-checkbox v-model="dataFormat" :disabled="step == 0||deviceId==''" @change="changeLoginStr">HEX
                  </el-checkbox>
                </div>
                <div style="margin-top: 10px;">
                  登录包：&nbsp;
                  <el-radio-group :disabled="step == 0||deviceId==''" v-model="loginType" style="width: 60%"
                    @change="changeLoginStr">
                    <el-radio :label="1">网关编号&nbsp;&nbsp;&nbsp;</el-radio>
                    <el-radio :label="2">字符串</el-radio>
                  </el-radio-group>
                </div>

                <el-input :disabled="step == 0||deviceId==''||loginType!=2" v-model="loginStr" placeholder="填写登录包字符串"
                  style="width: 100%">
                  <el-button slot="append" @click="sendLoginOrHeartbeat(1)"
                    :disabled="step == 0||deviceId==''||!loginType||loginStr==''" style="color:white;"
                    :style="{'background-color': (step == 0||deviceId==''||!loginType||loginStr=='')?'#A0CFFF':'#409EFF'}">
                    登录
                  </el-button>
                </el-input>
                <div style="margin-top: 10px">
                  <el-checkbox v-model="haveHeartbeat" :disabled="step == 0||deviceId==''" @change="changeHeartData">心跳
                  </el-checkbox>
                  <el-input v-model="heartbeatStr" :disabled="step == 0||deviceId==''" @blur="changeHeartData"
                    placeholder="请输入字符串" style="width: 50%"></el-input>
                  <el-input v-model="heartbeatCycle" :disabled="step == 0||deviceId==''" @blur="changeHeartData"
                    @change="checkHeartbeatCycle" placeholder="间隔" style="width: 30%">
                    <span slot="append">s</span>
                  </el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content stepContainer">
                <div>
                  填写发送报文(16进制格式)：
                </div>
                <el-input style="margin-top: 15px" :rows="8" type="textarea" placeholder="请输入报文内容(16进制格式)"
                  v-model="messageContent" maxlength="150" show-word-limit></el-input>
                <div style="text-align: center;margin-top: 10px">
                  <el-button type="primary" round :disabled="step == 0||deviceId==''||messageContent==''"
                    @click="sendMessage">发送报文</el-button>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content stepContainer">
                <div>
                  平台日志
                  <span style="float: right">
                    <el-checkbox v-model="refresh" @change="changeRefresh">实时刷新</el-checkbox>
                    <el-link icon="el-icon-refresh" @click="getLogList" style="margin-left:5px">刷新</el-link>
                    <el-link icon="el-icon-document-delete" @click="clearLogList" style="margin-left:5px">清空日志</el-link>
                  </span>
                </div>
                <div style="margin-top: 15px;height:600px;overflow-y: scroll;">
                  <el-timeline>
                    <el-timeline-item :timestamp="dateFormat(item.timestamp)" placement="top"
                      v-for="(item,index) in logList" :key="index">
                      <el-card>
                        <h4 :style="{color:item.severity=='ERROR'?'#E57979':item.severity=='WARN'?'#FFD767':'#A0CFFF'}">
                          {{item.severity}}</h4>
                        <p>{{item.rest}}</p>
                      </el-card>
                    </el-timeline-item>
                  </el-timeline>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  import API from "../../api/api";
  import dayjs from "dayjs"
  export default {
    data() {
      return {
        step: 0,
        deviceId: "", //选中设备
        devDisable: false, //是否禁用设备下拉框
        deviceList: [], //设备下拉列表
        messageContent: '', //报文消息
        refresh: true, //实时刷新
        time: '', //连接时间
        commuType: '', //客户端类型
        moduleCode: '', //关联网关
        logList: [], //平台日志
        startTime: '', //日志查询开始时间
        currentTime: '', //当前时间
        interval: null, //定时器
        loginType: null, //注册登录类型
        loginStr: '', //注册包数据
        haveHeartbeat: false, //是否上报心跳
        heartbeatStr: '', //心跳数据
        heartbeatCycle: 300, //心跳周期
        heartbeatInterval: null, //心跳包定时器
        dataFormat: false, //注册包和心跳包格式 false表示格式为字符串，true表示格式为hex
      }
    },
    created() { },
    methods: {

      /***********************获取设备下拉列表************************/
      queryDeviceList() {
        let para = {
          //          commuType: sessionStorage.getItem('commuType'),
          pageSize: 999999,
          currentPage: 1
        };
        API.platformDevDevicePage(para).then(res => {
          if (res.code == 1) {
            this.deviceList = res.data.resultPage;
          }
        });
      },
      /***********************调试接口************************/
      //连接后台
      connect() {
        let para = {
          deviceId: this.deviceId,
        };
        API.platformDevDebugConnect(para).then(res => {
          if (res.code == 1) {
            this.step = 1; //完成步骤一
            this.time = res.data.time
            this.commuType = res.data.commuType
            this.moduleCode = res.data.moduleCode
            this.startTime = res.data.time
            this.currentTime = res.data.time
            if (this.refresh) { //如果选择实时刷新，启动定时器
              this.interval = setInterval(this.getLogList, 5000);
            }
            this.$message.success("连接后台成功！")
          } else {
            this.$message.error("连接后台失败！");
          }
        });

      },
      //断开连接
      breakOff() {
        let para = {
          date: this.time,
          commuType: this.commuType,
        };
        API.disconnectDebug(para).then(res => {
          if (res.code == 1) {
            this.step = 0 //恢复编辑步骤一
            this.$message.success("已断开连接。")
            this.haveHeartbeat = false
            if (this.heartbeatInterval) {
              clearInterval(this.heartbeatInterval);
            }
            if (this.interval) {
              clearInterval(this.interval);
            }
          } else {
            this.$message.warning(res.msg)
          }
        });
      },
      sendLoginOrHeartbeat(type) { //发送登录报文
        //type:1登录包，2心跳包
        var msg = type == 1 ? this.loginStr : this.heartbeatStr
        if (!type || this.time == '' || msg.length < 1) {
          this.$message.warning("参数配置不全");
        }
        if (!this.dataFormat) {
          msg = this.stringToHex(msg);
        }
        let para = {
          message: msg,
          date: this.time,
          commuType: this.commuType,
        };
        API.sendDebugMessage(para).then(res => {
          if (res.code == 1) {
            if (type == 1) {
              this.$message.success("登录成功。")
            } else {
              console.log("---心跳发送---");
            }
          } else {
            this.$message.warning(res.msg)
          }
        });
      },
      //发送报文
      sendMessage() {
        if (this.step < 2) {
          this.step = 2;
        }
        let para = {
          message: this.messageContent,
          date: this.time,
          commuType: this.commuType,
        };
        API.sendDebugMessage(para).then(res => {
          if (res.code == 1) {
            if (this.step != 3) {
              this.step = 3
            }
            this.$message.success("报文发送成功。")
          } else {
            this.$message.warning(res.msg)
          }
        });
      },
      /*****************************日志获取******************************/
      //获取平台日志
      getLogList() {
        this.currentTime = this.currentTime + 5000 //修改当前时间，定时器为5000
        if (this.step < 2) { //未发送报文，无需实时监控
          return false;
        }
        let para = {
          startTime: dayjs(this.startTime).unix() * 1000,
          endTime: dayjs(this.currentTime).unix() * 1000,
          moduleCode: this.moduleCode,
          pIntGetCount: 999,
          startRow: 1
        };
        /*显示加载条*/
        API.platformMduModuleLog(para)
          .then(res => {
            if (res.code == 1) {
              this.logList = res.data.resultPage;
            } else {
              this.$message.error(res.msg);
            }
          })

      },
      /***************************辅助功能按钮******************************/
      //登录包改变时
      changeLoginStr() {
        if (this.moduleCode == '') {
          this.$message.warning("请选择设备并连接后台");
          return false;
        }
        if (this.loginType == 1) {
          this.loginStr = this.moduleCode
          if (this.dataFormat) {
            this.loginStr = this.stringToHex(this.loginStr)
          }
        } else if (this.loginType == 2) {
          this.loginStr = ''
        }
      },
      //心跳包参数改变时
      changeHeartData() {
        clearInterval(this.heartbeatInterval);
        if (this.haveHeartbeat && this.heartbeatStr != '') { //开启心跳包
          var self = this;
          this.heartbeatInterval = setInterval(function () {
            self.sendLoginOrHeartbeat(2)
          }, this.heartbeatCycle * 1000);
          this.sendLoginOrHeartbeat(2)
        }
      },
      //校验心跳间隔格式
      checkHeartbeatCycle() {
        this.heartbeatCycle = this.heartbeatCycle.replace(/[^0-9]/ig, "");
        this.heartbeatCycle = this.heartbeatCycle.length > 0 ? parseInt(this.heartbeatCycle) : 0
      },
      //定时刷新
      changeRefresh() {
        if (this.refresh && this.interval == null) { //设置为定时刷新，并未启动定时器时，启动定时器
          this.interval = setInterval(this.getLogList, 5000);
        } else if (!this.refresh) { //设置为非定时刷新，关闭定时器
          clearInterval(this.interval);
          this.interval = null
        }
      },
      //清空日志
      clearLogList() {
        this.startTime = this.currentTime + 0
        this.logList = [];
        this.getLogList();
      },
      //格式化时间
      dateFormat(time) {
        return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
      },
      stringToHex(str) { //字符串转hex
        var val = "";
        for (var i = 0; i < str.length; i++) {
          if (val == "") {
            val = str.charCodeAt(i).toString(16);
          } else {
            val += str.charCodeAt(i).toString(16);
          }
        }
        return val;
      }
    },
    mounted() {
      this.queryDeviceList();
      if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
      }
      if (this.interval) {
        clearInterval(this.interval);
      }
    },
    destroyed() {
      if (this.time != '') {
        this.breakOff();
      }
      if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
      }
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }

</script>


// WEBPACK FOOTER //
// src/views/platform/equimentDebug.vue